import React from 'react';
import { Modal, Typography, Button } from 'antd';
import { MailOutlined, DownloadOutlined } from '@ant-design/icons';
import { Invoice } from '../../services/paymentService';
import InvoicePage from '../../pages/InvoicePage';

const { Title, Text } = Typography;

interface InvoiceDetailModalProps {
  visible: boolean;
  onClose: () => void;
  invoice: Invoice | null;
  onSendEmail?: () => void;
  onDownloadPDF?: () => void;
}

/**
 * Thin Modal wrapper around InvoicePage (embedded mode).
 * Used from the dashboard tooltip / quick-view path.
 */
const InvoiceDetailModal: React.FC<InvoiceDetailModalProps> = ({
  visible,
  onClose,
  invoice,
  onSendEmail,
  onDownloadPDF,
}) => {
  if (!invoice) return null;

  return (
    <Modal
      title={
        <div>
          <Title level={4} style={{ margin: 0 }}>
            Invoice Details
          </Title>
          <Text type="secondary" style={{ fontSize: 14 }}>
            {invoice.invoice_number}
          </Text>
        </div>
      }
      open={visible}
      onCancel={onClose}
      width={900}
      centered
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
        <Button
          key="email"
          icon={<MailOutlined />}
          onClick={onSendEmail}
          disabled={!onSendEmail}
        >
          Send to Customer
        </Button>,
        <Button
          key="download"
          type="primary"
          icon={<DownloadOutlined />}
          onClick={onDownloadPDF}
          disabled={!onDownloadPDF}
        >
          Download PDF
        </Button>,
      ]}
    >
      {/* Render the full InvoicePage in embedded mode — no back button, no double fetch */}
      <InvoicePage embedded invoiceId={invoice.id} />
    </Modal>
  );
};

export default InvoiceDetailModal;
